export type AppLanguage = "ar" | "en";

const STORAGE_KEY = "app_lang";
const LANGUAGE_EVENT = "app-language-change";

export function getStoredLanguage(): AppLanguage {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw === "ar" || raw === "en" ? raw : "ar";
}

export function applyLanguage(language: AppLanguage): void {
  document.documentElement.lang = language;
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  localStorage.setItem(STORAGE_KEY, language);
  window.dispatchEvent(new CustomEvent(LANGUAGE_EVENT, { detail: language }));
}

export function onLanguageChange(callback: (language: AppLanguage) => void): () => void {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<AppLanguage>).detail;
    callback(detail || getStoredLanguage());
  };

  const storageHandler = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) {
      callback(getStoredLanguage());
    }
  };

  window.addEventListener(LANGUAGE_EVENT, handler);
  window.addEventListener("storage", storageHandler);
  return () => {
    window.removeEventListener(LANGUAGE_EVENT, handler);
    window.removeEventListener("storage", storageHandler);
  };
}


